module.exports = __webpack_public_path__ + "img/about_us_short.eca34565.png";